import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=8b4116e6&scoped=true"
import script from "./Culture.vue?vue&type=script&lang=js"
export * from "./Culture.vue?vue&type=script&lang=js"
import style0 from "./Culture.vue?vue&type=style&index=0&id=8b4116e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4116e6",
  null
  
)

export default component.exports